import PortfolioSizeStep from "../wizard-steps/PortfolioSizeStep";
import AssetAllocationStep from "../wizard-steps/AssetAllocationStep";
import InvestmentStrategyStep from "../wizard-steps/InvestmentStrategyStep";
import AltsAllocationSimulatorStep from "../wizard-steps/AltsAllocationSimulatorStep";
import PotentialReturnsStep from "../wizard-steps/PotentialReturnsStep";
import RiskReturnChartStep from "../wizard-steps/RiskReturnChartStep";
import PortfolioComparisonStep from "../wizard-steps/PortfolioComparisonStep";
import { WizardStepConfig } from "./types";
import { StrategyType } from "../wizard-steps/investment-strategy/InvestmentStrategyContext";

export const createWizardSteps = (
  handleNext: () => void,
  onStrategySelect: (strategy: StrategyType) => void,
  selectedStrategy?: StrategyType
): WizardStepConfig[] => [
  { 
    number: 1, 
    title: "Portfolio Value", 
    component: <PortfolioSizeStep onContinue={handleNext} /> 
  },
  { 
    number: 2, 
    title: "Asset Allocation", 
    component: <AssetAllocationStep onContinue={handleNext} /> 
  },
  { 
    number: 3, 
    title: "Investment Strategy", 
    component: <InvestmentStrategyStep onContinue={handleNext} onStrategySelect={onStrategySelect} /> 
  },
  { 
    number: 4, 
    title: "Alts Allocations", 
    component: <AltsAllocationSimulatorStep onContinue={handleNext} selectedStrategy={selectedStrategy} /> 
  },
  { 
    number: 5, 
    title: "Potential Returns", 
    component: <PotentialReturnsStep onContinue={handleNext} /> 
  },
  { 
    number: 6, 
    title: "Risk-Return Chart", 
    component: <RiskReturnChartStep onContinue={handleNext} /> 
  },
  { 
    number: 7, 
    title: "Portfolio Comparison", 
    component: <PortfolioComparisonStep onContinue={handleNext} /> 
  },
];